// extracted by mini-css-extract-plugin
export default {"wrapRenderStep":"AddBackground_wrapRenderStep__2SNFp","wrapImage":"AddBackground_wrapImage__wILTJ"};